"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NarrowFooter = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _socialMediaButtons = require("./socialMediaButtons");
var _privacyPolicy = require("../../privacyPolicy");
var _copyright = require("./copyright");
var _icons = require("../../icon/icons");
var _narrowFooter = require("./narrowFooter.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// TODO: WD-872
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const svg = (0, _jsxRuntime.jsx)(_reactInlinesvg.default, {
  src: _icons.wonderlicLogo,
  css: {
    height: '2.4rem'
  }
});
const NarrowFooter = ({
  privacyPolicyUrl,
  className
}) => {
  return (0, _jsxRuntime.jsx)(_narrowFooter.Footer, {
    className: className,
    children: (0, _jsxRuntime.jsxs)(_narrowFooter.Container, {
      children: [(0, _jsxRuntime.jsx)(_narrowFooter.StyledMedia, {
        children: (0, _jsxRuntime.jsx)(_narrowFooter.StyledLink, {
          href: "https://wonderlic.com",
          title: "Wonderlic Homepage",
          children: svg
        })
      }), (0, _jsxRuntime.jsxs)(_narrowFooter.FooterContent, {
        children: [(0, _jsxRuntime.jsx)(_privacyPolicy.ShortenedPrivacyPolicy, {
          url: privacyPolicyUrl
        }), (0, _jsxRuntime.jsx)(_copyright.ShortenedCopyright, {}), (0, _jsxRuntime.jsx)(_socialMediaButtons.SocialMediaButtons, {})]
      })]
    })
  });
};
exports.NarrowFooter = NarrowFooter;